<template>
  <div class="rebind-phone">
    <NavBar
      class="nav"
      title="返利查询"
      :goBack="
        () => {
          this.$router.go(-1);
        }
      "
    />
    <van-form @submit="onSubmit">
      <!-- <van-field
        v-model="form.phone"
        :name="$t('login.phone')"
        :label="$t('login.phone')"
        :placeholder="$t('login.phone')"
        :rules="[
          { required: true, message: $t('login.phoneRequired') },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: $t('login.rightPhone'),
          },
        ]"
      /> -->
      <div style="margin: 16px">
        <van-button
          class="login-btn"
          :loading="confirmLoading"
          block
          type="primary"
          size="large"
          native-type="submit"
        >
          {{ $t("banQuery.查询") }}
        </van-button>
      </div>
    </van-form>

    <van-cell-group title="返利结果" v-if="roleInfo.status === 1">
      <van-cell
        title="月卡返还"
        :value="roleInfo.monthly_card_rebate"
      ></van-cell>
      <van-cell
        title="月石精胚返还"
        :value="roleInfo.monthly_stone_refund"
      ></van-cell>
    </van-cell-group>
    <van-overlay :show="errShow" :z-index="1000" @click="errShow = false">
      <div class="wrapper">
        <div class="box">
          <div class="title">查询失败</div>
          <div class="tip">{{ errInfo }}</div>
          <van-button block type="primary" size="large" @click="handleBack">
            {{ $t("accountInfo.返回") }}
          </van-button>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { apiGetReBateInfo } from "@/api/user";
// import dayjs from 'dayjs';
import { mapState } from "vuex";
import storage from "@/utils/storage";

export default {
  name: "RoleQuery",
  data() {
    return {
      form: {
        phone: "",
      },
      confirmLoading: false,
      errShow: false,
      errInfo: "",
      roleInfo: {
        status: 0,
        monthly_card_rebate: "",
        monthly_stone_refund: "",
      },
    };
  },
  watch: {},
  computed: {
    ...mapState({
      defaultRoleInfo: (state) => state.defaultRoleInfo,
    }),
  },
  created() {
    const { game_id } = this.$route.query;
    if (game_id) {
      sessionStorage.setItem("game_id", Number(game_id));
    }
    this.onSubmit();
  },
  mounted() {},
  methods: {
    handleBack() {
      this.$router.back();
    },
    // 查询
    onSubmit() {
      const { session_id } = this.$route.query;
      const params = {
        session_id: session_id ? Number(session_id) : undefined,
      };
      this.confirmLoading = true;
      apiGetReBateInfo(params)
        .then((res) => {
          if (res.code === 0) {
            this.roleInfo = {
              status: 1,
              monthly_card_rebate:
                res.data.monthly_card_rebate ||
                res.data.monthly_card_rebate === 0
                  ? res.data.monthly_card_rebate + "个"
                  : "",
              monthly_stone_refund:
                res.data.monthly_stone_refund || res.data.monthly_stone_refund
                  ? res.data.monthly_stone_refund + "个"
                  : "",
            };
          } else if (res.code === -1) {
            this.errInfo = res.msg;
            this.errShow = true;
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    // height: 200px;
    padding: 20px;
    background: #fff;
    .title {
      margin-bottom: 20px;
      font-size: 17px;
      font-weight: bold;
      color: #000;
    }
    .tip {
      margin-bottom: 20px;
      color: #333;
      font-size: 15px;
    }
  }
}
/deep/ .van-row {
  color: #646566;
  background-color: #fff;
  &.header {
    color: #000;
    font-size: 14px;
  }
  .van-col {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 4px;
    border-bottom: 1px solid #ebedf0;
  }
}
/deep/ .van-search {
  padding: 0;
}
</style>
